import React from 'react';
import { render } from 'react-dom';
import injectTapEventPlugin from 'react-tap-event-plugin';

// Polyfills
import 'core-js/fn/array/find';
import 'core-js/es6/promise';
import 'core-js/fn/promise';

import Root from './containers/Root';

injectTapEventPlugin();

render(<Root />, document.getElementById('root'));

require('file?name=[name].[ext]!./index.html'); // eslint-disable-line



// WEBPACK FOOTER //
// ./src/index.js